import React, { useState, useEffect } from "react";
import { Alert, Container, Grid, Card, CardContent, Typography, TextField, Button ,Autocomplete} from "@mui/material";
import { Formik, Form } from "formik";
import SelectBox from "../../../components/common components/select";
import InputButton from "../../../components/common components/inputButton";
import InputBox from "../../../components/common components/inputBox";
// import { getCities } from "../../services/cityServices";
// import { getStates } from "../../services/stateServices";
// import { addBoy } from "../../services/DeliveryBoyService";
// import AutocompleteBox from "../../../components/common components/autoComplete";
import { getCountries, getStates, fetchDeliveryManagers, getCities, getPinCode, addDeliveryBoy } from "../../../redux/deliverySlice";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

const AddDeliverydeliveryBoy = (editData) => {
  const isEdit = editData && editData._id;
  const dispatch = useDispatch()
  const [cId, setCId] = useState("")
  const [sId,setSId] = useState("")
  const [ciId,setCiId] = useState("")

  const managerList =
    useSelector((state) => state.deliveryModule.deliveryManagerData) || [];
  const countryList =
    useSelector((state) => state.deliveryModule.countryDetails) || [];
  const stateList =
    useSelector((state) => state.deliveryModule.stateDetails) || [];
  const cityList =
    useSelector((state) => state.deliveryModule.cityDetails) || [];
  const pinCodeList =
    useSelector((state) => state.deliveryModule.pinCodeDetails) || [];
    // Map the data to the format required by the autocomplete component
    const deliveryManagerOption = managerList.map((m) => ({
      label: m.firstName,
      value: m._id,
    }));
    const countryOption = countryList.map((m) => ({
      label: m.name,
      value: m._id,
    }));
    const stateOption = stateList.map((m) => ({
      label: m.name,
      value: m._id,
    }));
   const cityOption = cityList.map((m) => ({
     label: m.name,
     value: m._id,
   }));
   const pinCodeOption = pinCodeList.map((m) => ({
     label: m.zipcode,
     value: m._id,
   }));
    useEffect(() => {
      dispatch(fetchDeliveryManagers());
    }, [dispatch]);
  
    useEffect(() => {
      // getCountryList()
      dispatch(getCountries());
      const stateData = {
        limit: 10,
        skip: 0,
        name: "",
        countryId: cId,
      };
      dispatch(getStates(stateData));
    }, [dispatch, cId]);
    
    useEffect(() => {
      const citiesData = {
        limit: 10,
        skip: 0,
        name: "",
        countryId: cId ,
        stateId: sId,
      };
      dispatch(getCities(citiesData));
    }, [dispatch, cId, sId]);
      useEffect(() => {
        const pinCodeData = {
          limit: 10,
          skip: 0,
          zipcode: "",
          countryId: cId,
          stateId: sId,
          cityId: ciId,
        };
        dispatch(getPinCode(pinCodeData));
      }, [dispatch, cId, sId,ciId]);

  return (
    <Container>
      <Grid justifyContent="center" mt={4}>
        <Grid item xs={12} sm={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Add Delivery Boy
              </Typography>
              <Formik
                initialValues={{
                  name: editData?.name || "",
                  email: editData?.email || "",
                  mobileNumber: editData?.mobileNumber || "",
                  emergencycontactNo: editData?.emergencycontactNo || "",
                  language: editData?.language || "",
                  addresses: editData?.addresses || [],
                  isExport: editData?.isExport || "",
                  countryId: editData?.countryId || "",
                  stateId: editData?.stateId || "",
                  cityId: editData?.cityId || "",
                  zipcode: editData?.zipcodes || [],
                  zipcodes: editData?.zipcodes || [],
                  managerId: editData?.managerId || "",
                  contactNo: editData?.contactNo || "",
                  // ...rest,
                }}
                onSubmit={(values) => {
                  // console.log("Values ::", values);
                  const formatedValues = { ...values };
                  delete formatedValues.country;
                  delete formatedValues.state;
                  delete formatedValues.city;
                  delete formatedValues.zipcode;
                  delete formatedValues.manager;
                  console.log("Formated Values ::", formatedValues);

                  // saveDeliverydeliveryBoy(formatedValues);
                  dispatch(addDeliveryBoy(formatedValues));
                }}
              >
                {({
                  handleSubmit,
                  values,
                  handleChange,
                  touched,
                  errors,
                  handleBlur,
                  handleReset,
                }) => (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Name"
                          name="name"
                          type="text"
                          value={values.name}
                          onChange={handleChange}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Email Id"
                          name="email"
                          type="text"
                          value={values.email}
                          onChange={handleChange}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <img
                          className="auth-form__logo d-table mx-auto mb-3"
                          src={
                            require("../../../assets/images/browse.svg").default
                          }
                          alt="Shards Dashboards - Change Password Template"
                          width="250px"
                        />
                        <button className="odd-browse-btn" type="file">
                          Browse
                        </button>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <label htmlFor="number">
                          Contact Number
                          {/* <span style={{ color: "red" }}>*</span> */}
                        </label>
                        <InputBox
                          id="number"
                          name="number"
                          type="text"
                          placeholder="Enter contact number"
                          value={values.number}
                          className=""
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label htmlFor="monumber">
                          Mobile Number
                          <span style={{ color: "red" }}>*:&nbsp;</span>
                        </label>
                        <InputBox
                          id="monumber"
                          name="mobileNumber"
                          type="text"
                          placeholder="Enter contact number"
                          value={values.mobileNumber}
                          className=""
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <label htmlFor="emergencyNumber">
                          Emergency Contact Number
                          <span style={{ color: "red" }}>*:&nbsp;</span>
                        </label>

                        <InputBox
                          id="emergencyNumber"
                          name="emergencyNumber"
                          type="text"
                          placeholder="Enter emergency number"
                          value={values.emergencyNumber}
                          className=""
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>

                        <TextField
                          name="addresses"
                          className="md-input"
                          label={"Addresses"}
                          multiline
                          rows={4}
                          value={values.addresses}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.addresses &&
                            Boolean(errors.addresses)
                          }
                          helperText={
                            touched.addresses &&
                            errors.addresses
                          }
                          inputProps={{
                            maxLength: 300,
                          }}
                          // helperText={`${values.addresses.length}/300`}
                        />
                      </Grid>
                      {/* <Col md="12" className="form-group"></Grid> */}
                      <Grid item xs={12} sm={6}>
                        {/* <SelectBox
                                className=""
                                options={deliveryManager}
                                onChange={handleChange}
                                name="deliveryManager"
                                id="deliveryManager"
                                errorMessage=""
                                placeholder="Select State"
                              /> */}
                        {/* <AutocompleteBox
                          className="custume-delivery-manger-edit"
                          // options={deliveryManager}
                          API={fetchDeliveryManagers}
                          // options={countryListSelect}
                          onChange={handleChange}
                          name="deliveryManager"
                          value={values.deliveryManager}
                          keyMapper={{ label: "name", id: "_id" }}
                          isEdit={isEdit}
                          // errorMessage=""
                          // label="Delivery Manager"
                          placeholder="Select Manager"
                          //
                        />
                        {touched.deliveryManager && errors.deliveryManager ? (
                          <div className="errorMessage">
                            {errors.deliveryManager}
                          </div>
                        ) : null} */}
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="md-input"
                          options={deliveryManagerOption}
                          getOptionLabel={(option) => option.label || ""}
                          value={
                            deliveryManagerOption.find(
                              (option) => option.label === values.manager
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            // setProducts('productName', newValue ? newValue.label : '');
                            // console.log("NewValue:",newValue)
                            // handleChange({ target: { name: 'productName', value: newValue?.label || '' } });
                            handleChange({
                              target: {
                                name: "managerId",
                                value: newValue?.value || "",
                              },
                            });
                            const selectedManager = deliveryManagerOption.find(
                              (option) => option.label === newValue?.label
                            );
                            // handleChange({ target: { name: 'productId', value: newValue?.id || '' } });
                            handleChange({
                              target: {
                                name: "manager",
                                value: selectedManager?.label || "",
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"Manager Name"}
                              name="manager"
                              error={touched.manager && Boolean(errors.manager)}
                              helperText={touched.manager && errors.manager}
                            />
                          )}
                        />
                      </Grid>
                      {/* <Col md="12" className="form-group"></Grid> */}

                      <Grid item xs={12} sm={6}>
                        <label htmlFor="username">
                          Username
                          <span style={{ color: "red" }}>*:&nbsp;</span>
                        </label>

                        <InputBox
                          id="userName"
                          name="userName"
                          type="text"
                          placeholder="Enter user name"
                          value={values.userName}
                          className=""
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label htmlFor="password">
                          Password
                          <span style={{ color: "red" }}>*:&nbsp;</span>
                        </label>

                        <InputBox
                          id="password"
                          name="password"
                          type="password"
                          placeholder="Enter password"
                          value={values.password}
                          className=""
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {/* <label htmlFor="country">Country</label> */}
                        {/* <SelectBox
                          className=""
                          options={countryListSelect}
                          onChange={handleChange}
                          name="country"
                          id="country"
                          errorMessage=""
                          placeholder="Select Country"
                        /> */}
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="md-input"
                          options={countryOption}
                          getOptionLabel={(option) => option.label || ""}
                          value={
                            countryOption.find(
                              (option) => option.label === values.country
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            console.log("selectedCountry", newValue?.value);
                            setCId(newValue?.value);
                            handleChange({
                              target: {
                                name: "countryId",
                                value: newValue?.value || "",
                              },
                            });
                            const selectedCountry = countryOption.find(
                              (option) => option.label === newValue?.label
                            );
                            // handleChange({ target: { name: 'productId', value: newValue?.id || '' } });
                            handleChange({
                              target: {
                                name: "country",
                                value: selectedCountry?.label || "",
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"Select Country"}
                              name="country"
                              error={touched.country && Boolean(errors.country)}
                              helperText={touched.country && errors.country}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="md-input"
                          options={stateOption}
                          getOptionLabel={(option) => option.label || ""}
                          value={
                            stateOption.find(
                              (option) => option.label === values.state
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            setSId(newValue?.value);
                            handleChange({
                              target: {
                                name: "stateId",
                                value: newValue?.value || "",
                              },
                            });
                            const selectedState = stateOption.find(
                              (option) => option.label === newValue?.label
                            );
                            // handleChange({ target: { name: 'productId', value: newValue?.id || '' } });
                            handleChange({
                              target: {
                                name: "state",
                                value: selectedState?.label || "",
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"Select State"}
                              name="state"
                              error={touched.state && Boolean(errors.state)}
                              helperText={touched.state && errors.state}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="md-input"
                          options={cityOption}
                          // multiple={true}
                          getOptionLabel={(option) => option.label || ""}
                          value={
                            cityOption.find(
                              (option) => option.label === values.city
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            setCiId(newValue?.value);
                            console.log("Cities new values::", newValue);
                            handleChange({
                              target: {
                                name: "cityId",
                                value: newValue?.value || "",
                              },
                            });
                            const selectedCity = cityOption.find(
                              (option) => option.label === newValue?.label
                            );
                            // handleChange({ target: { name: 'productId', value: newValue?.id || '' } });
                            handleChange({
                              target: {
                                name: "city",
                                value: selectedCity?.label || "",
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"Select City"}
                              name="city"
                              error={touched.city && Boolean(errors.city)}
                              helperText={touched.city && errors.city}
                            />
                          )}
                        />
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="md-input"
                          options={pinCodeOption}
                          getOptionLabel={(option) => option.label || ""}
                          value={
                            pinCodeOption.find(
                              (option) => option.label === values.zipcode
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            handleChange({
                              target: {
                                name: "zipcode",
                                value: newValue?.label || "",
                              },
                            });
                            const selectedpinCode = pinCodeOption.find(
                              (option) => option.label === newValue?.label
                            );
                            // handleChange({ target: { name: 'productId', value: newValue?.id || '' } });
                            handleChange({
                              target: {
                                name: "_id",
                                value: selectedpinCode?.value || "",
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"Select Pin Code"}
                              name="zipcode"
                              error={touched.zipcode && Boolean(errors.zipcode)}
                              helperText={touched.zipcode && errors.zipcode}
                            />
                          )}
                        />
                      </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          multiple
                          disablePortal
                          id="combo-box-demo"
                          className="md-input"
                          options={pinCodeOption}
                          getOptionLabel={(option) => option.label || ""}
                          value={
                            pinCodeOption.filter((option) =>
                              values.zipcode.includes(option.label)
                            ) || []
                          }
                          onChange={(event, newValue) => {
                            console.log;
                            const selectedLabels = newValue.map(
                              (option) => option.label
                            );
                            const selectedIds = newValue.map(
                              (option) => option.value
                            );

                            handleChange({
                              target: {
                                name: "zipcode",
                                value: selectedLabels,
                              },
                            });

                            handleChange({
                              target: {
                                name: "zipcodes",
                                value: selectedIds,
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"Select Pin Codes"}
                              name="zipcode"
                              error={touched.zipcode && Boolean(errors.zipcode)}
                              helperText={touched.zipcode && errors.zipcode}
                            />
                          )}
                        />
                      </Grid>

                      {/* </Row> */}
                      {/* <Row className="flex-row-reverse mx-4 my-4"> */}
                      <Grid container justifyContent="flex-end" mt={2}>
                        <button
                          className="btn btn-light grey-btn md_btn me-0"
                          onClick={() => {}}
                        >
                          Reset button
                        </button>
                        <button
                          // variant="contained"
                          // color="primary"
                          className="btn btn-primary greeen-btn md_btn"
                          type="submit"
                          onClick={handleSubmit}
                          // ml={2}
                        >
                          Submit button
                        </button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
    // </div>
  );
}
export default AddDeliverydeliveryBoy;
